import { dsColorNew } from '@palette'
import { dsRepricingToggleSx } from 'Pages/DsRepricing/Page/@components/toggleSx'

/**
 * The app's controls for everything inside the Setup tabs, set once on their container (and on the
 * Paper of their dialogs, which portal outside it) instead of in every button of seven thousand
 * lines: primary buttons in app blue (the theme's default button is the contained one), outlined ones as the app's secondary button, destructive
 * outlined ones in soft red, no capitals, no shadows, and every toggle group as the pill toggle the
 * Strategies wizard uses. The same approach as My Business (`mbScopeSx`).
 */
export const setupScopeSx = {
	'& .MuiButton-root': {
		textTransform: 'none', borderRadius: '8px', boxShadow: 'none',
		'&:hover': { boxShadow: 'none' },
	},
	'& .MuiButton-containedPrimary': {
		bgcolor: dsColorNew.appBlue, color: dsColorNew.white,
		'&:hover': { bgcolor: dsColorNew.appBlueHover },
	},
	'& .MuiButton-outlinedPrimary': {
		color: dsColorNew.textDark, borderColor: dsColorNew.grayBorder, bgcolor: dsColorNew.white,
		'&:hover': { borderColor: dsColorNew.appBlue, bgcolor: dsColorNew.hoverBgLight },
	},
	'& .MuiButton-outlinedError': {
		color: dsColorNew.dangerRed, borderColor: dsColorNew.dangerBorder, bgcolor: dsColorNew.white,
		'&:hover': { borderColor: dsColorNew.dangerRed, bgcolor: dsColorNew.dangerBg },
	},
	'& .MuiToggleButtonGroup-root': dsRepricingToggleSx,
}

export default setupScopeSx
